export function clean(s: string, ss: string[]) {
    const mask = '*';

    let lower = s.toLowerCase();
    for (let p of ss) {
        lower = lower.replace(p, (w) => mask.repeat(w.length));
    }

    let result = [];
    let len = s.length;
    for (let i = 0; i < len; i++) {
        if (lower[i] === mask) {
            result.push(mask);
        }
        else {
            result.push(s[i]);
        }
    }

    return result.join('');
}
